import React, { useState, useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import PaymentSubHeader from '../parts/PaymentSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// PaymentHistoryList
const PaymentHistoryList = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false);
  let [paymentHistory, setPaymentHistory] = useState([])
  let [pageNumber, setPageNumber] = useState(0)

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    // get payment history
    await _getPaymentHistory(login_token, 0)
  }

  // get payment history
  let _getPaymentHistory = async (login_token, page_number) => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getPaymentHistory({
        login_token: login_token,
        page_number: page_number,
      })
      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // list1
      if (_results.list1) {
        setPaymentHistory(_results.list1)
      }

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  return (
    <div>

      <Header />

      <PaymentSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 400,
      }}>

        <ListGroup style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <ListGroupItem style={{
            backgroundColor: '#ffffff',
            color: '#555555',
          }}>
            <Row>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                Date
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                ID
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                Amount
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                Notes
              </Col>
            </Row>
          </ListGroupItem>

          {paymentHistory.map((item, idx) => (
            <ListGroupItem key={item._id} style={{
              backgroundColor: '#ffffff',
              color: '#555555',
            }}>
              <Row>
                <Col md="3" xs="12">
                  {item.createdAt}
                </Col>
                <Col md="3" xs="12">
                  {item._id.substr(0,8)}
                </Col>
                <Col md="3" xs="12">
                  {item.amount_paid}
                </Col>
                <Col md="3" xs="12">
                  {item.product_name}
                </Col>
              </Row>
            </ListGroupItem>
          ))}

        </ListGroup>

      </Container>

      {/* footer */}
      <Footer />

    </div>
  )
}

export default PaymentHistoryList
